<template>
  <modal-vue
    :modal-active="modelValue"
    :show-close-button="true"
    :has-header-border="false"
    :has-footer-border="false"
    max-width="!w-[92vw] sm:!w-[529px] !max-w-[529px]"
    data-testid="confirm-delete-role-modal"
    @close="handleCancel"
  >
    <template #header>
      <p class="font-bold text-lg text-textPrimary">{{ props.title }}</p>
    </template>

    <div class="w-full flex justify-center mb-6 sm:mb-8 px-2 sm:px-0">
      <p
        class="text-center text-[#16161D] text-[15px] sm:text-[16px] font-normal leading-[22px] sm:leading-[24px] tracking-[0.08px]"
      >
        {{ props.description }}
      </p>
    </div>

    <template #footer>
      <div class="flex items-center gap-3 sm:gap-6 w-full">
        <template v-if="props.informational">
          <v-btn
            variant="flat"
            class="!flex-1 !h-12 !rounded !bg-[#2F7F91] !text-white !font-bold !normal-case !px-2 sm:!px-4"
            @click="handleCancel"
          >
            Entendi
          </v-btn>
        </template>

        <template v-else>
          <v-btn
            variant="flat"
            :disabled="loading"
            class="!flex-1 !h-12 !rounded !bg-[#2F7F91] !text-white !font-bold !normal-case !px-2 sm:!px-4"
            @click="handleCancel"
          >
            Cancelar
          </v-btn>

          <v-btn
            variant="outlined"
            :loading="loading"
            class="!flex-1 !h-12 !rounded !border-2 !border-[#DA1E28] !bg-white !text-[#DA1E28] !font-bold !normal-case !px-2 sm:!px-4"
            @click="handleConfirm"
          >
            Confirmar
          </v-btn>
        </template>
      </div>
    </template>
  </modal-vue>
</template>

<script setup lang="ts">
import ModalVue from '@/components/designSystem/modals/Modal.vue'

const props = defineProps<{
  modelValue: boolean
  loading?: boolean
  title: string
  description: string
  informational?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
  cancel: []
}>()

const handleCancel = (): void => {
  emit('update:modelValue', false)
  emit('cancel')
}

const handleConfirm = (): void => {
  emit('confirm')
}
</script>
